/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 11/21/17
 * Copyright All Rights Reserved
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { fetchToken } from 'actions/tokenCreators';
import tokenHelpers from 'support/tokenHelpers';
import FormGroup from 'components/forms/FormGroup';

/**
 * Renders a sign-in form and controls values in its inputs
 */
class SignInForm extends Component {
  /**
   * Defines initial local state and binds event handlers
   *
   * @param  {Object} props Configures component
   */
  constructor(props) {
    super(props);

    /**
     * stores values of email and password inputs
     * @type {Object}
     */
    this.state = {
      email: '',
      password: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  /**
   * Updates local state when input value changes
   * @param  {SyntheticEvent} event Change event trigger on an input
   * @return {undefined}
   */
  handleChange(event) {
    event.preventDefault();
    this.setState({
      [event.target.id.replace('Input', '')]: event.target.value,
    });
  }

  /**
   * Dispatches submitted input to the global data store
   * @param  {SyntheticEvent} event Submission event trigger on form
   * @return {undefined}
   */

  handleSubmit(event) {
    event.preventDefault();
    this.props.dispatch(fetchToken(this.state));
  }

  /**
   * Renders component
   * @return {Object}
   */
  render() {
    /**
     * if a valid token is present, redirect to the inputs page
     */
    if (tokenHelpers.isValid(this.props.token)) {
      return (
        <Redirect to={{ pathname: '/inputs' }} />
      );
    }

    let alert = null;
    if (this.props.errorMessage) {
      alert = (
        <div className="alert alert-danger">
          {this.props.errorMessage}
        </div>
      );
    }
    /**
     * Otherwise, render the sign in form
     */
    return (
      <form onSubmit={this.handleSubmit} className="sign-in-form">
        {alert}
        <FormGroup labelText="Email" forValue="emailInput">
          <input
            id="emailInput"
            className="form-control"
            type="email"
            value={this.state.email}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup labelText="Password" forValue="passwordInput">
          <input
            id="passwordInput"
            className="form-control"
            type="password"
            value={this.state.password}
            onChange={this.handleChange}
          />
        </FormGroup>
        <button type="submit" className="btn btn-primary" formNoValidate>Submit</button>
      </form>
    );
  }
}

SignInForm.defaultProps = {
  errorMessage: '',
};

SignInForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
};

export default SignInForm;
